/**
 * ============================================================================
 * EL-ARO
 * COMPONENT: Mega Content
 * FILE: assets/elaro-mega-content.js
 * ============================================================================
 */

class ElaroMegaContent {

    constructor(root) {

        this.root = root;

        this.initialize();

    }

    /*==========================================================================
      Initialize
    ==========================================================================*/

    initialize() {

        this.navigationItems = [

            ...this.root.querySelectorAll(
                "[data-mega-collection]"
            )

        ];

        this.heading = this.root.querySelector(
            "[data-editorial-heading]"
        );

        this.description = this.root.querySelector(
            "[data-editorial-description]"
        );

        this.button = this.root.querySelector(
            "[data-editorial-button]"
        );

        this.productGroups = [

            ...this.root.querySelectorAll(
                "[data-collection-products]"
            )

        ];

        this.bindEvents();

        this.activateDefault();

    }

    /*==========================================================================
      Events
    ==========================================================================*/

    bindEvents() {

        this.navigationItems.forEach(link => {

            link.addEventListener(

                "mouseenter",

                () => {

                    this.activate(link);

                }

            );

            link.addEventListener(

                "focus",

                () => {

                    this.activate(link);

                }

            );

        });

    }

    /*==========================================================================
      Default Collection
    ==========================================================================*/

    activateDefault() {

        const first = this.navigationItems[0];

        if (!first) {

            return;

        }

        this.activate(first);

    }

    /*==========================================================================
      Activate Collection
    ==========================================================================*/

    activate(link) {

        this.navigationItems.forEach(item => {

            item.closest(".elaro-mega-nav__item")
                ?.classList.remove("is-active");

        });

        link.closest(".elaro-mega-nav__item")
            ?.classList.add("is-active");

        this.updateEditorial(link);

        this.updateProducts(link);

    }

    /*==========================================================================
      Editorial
    ==========================================================================*/

    updateEditorial(link) {

        if (this.heading) {

            this.heading.textContent =
                link.dataset.collectionTitle || "";

        }

        if (this.description) {

            this.description.textContent =
                link.dataset.collectionDescription || "";

        }

        if (this.button) {

            this.button.href =
                link.dataset.collectionUrl || "#";

        }

    }

    /*==========================================================================
      Collection Products
    ==========================================================================*/

    updateProducts(link) {

        const handle = link.dataset.collectionHandle;

        if (!handle) {

            return;

        }

        this.productGroups.forEach(group => {

            if (

                group.dataset.collectionProducts === handle

            ) {

                group.hidden = false;

            }

            else {

                group.hidden = true;

            }

        });

    }

}

/*==============================================================================
  Manager
==============================================================================*/

class ElaroMegaContentManager {

    constructor() {

        this.initialize();

    }

    initialize() {

        document

            .querySelectorAll("[data-mega-menu]")

            .forEach(root => {

                if (

                    root.dataset.megaContentInitialized === "true"

                ) {

                    return;

                }

                new ElaroMegaContent(root);

                root.dataset.megaContentInitialized = "true";

            });

    }

}

/*==============================================================================
  Initialize
==============================================================================*/

const initializeMegaContent = () => {

    new ElaroMegaContentManager();

};

document.addEventListener(

    "DOMContentLoaded",

    initializeMegaContent

);

document.addEventListener(

    "shopify:section:load",

    initializeMegaContent

);

document.dispatchEvent(

    new CustomEvent(

        "mega-products:update"

    )

);